import { Session, SessionKeys } from 'common/services/-RFC.session.js';
/* eslint no-undef : 0 */
const _serviceDependencies = ['Auth', '$rootScope'];

/**
 * @ngdoc service
 * @name controllers.Root
 *
 * @description
 * Root controller
 */
class Root {

    /**
     * @param  {any} Auth
     * @param  {any} $rootScopeuth
     */
    constructor(Auth, $rootScope) {

        Auth.sendAcpPing();

        const urlParams = decodeURIComponent(Session.getValue(SessionKeys.ExtraUrlParams));

        // check if there are Spotlight newsletter campaign params
        if (urlParams && urlParams.indexOf('trial_source=ws_spotlight') > -1) {

            sessionStorage.setItem('TrialSourceSpotlight', 'ws_spotlight');

        }

        if (sessionStorage.getItem('TrialSourceSpotlight')) {

            $rootScope.isFromSpotlightNewsletterCampaign = true;

        }

    }

}

_serviceDependencies.push(Root);

angular.module('controllers')
    .controller('Root', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/root/root.js